export default {
    IDOSO: 1,
    GESTANTE: 2,
    PESSOA_COM_CRIANÇA_DE_COLO: 3,
    PESSOA_COM_DEFICIENCIA: 4,
    AUTISTA: 5,
    OBESO: 6
}